import React, { useState } from "react";
import FreeApp from "../Sections/Download/FreeApp";
import Footer from "../Footer/Footer";
import ContactForm from "../Sections/Contact/Form/ContactForm";
import Navbar from "../Navbar/Navbar";
const Contact = () => {
  const initialScale = 1;
  const minScale = 0.3;
  const maxScroll = 300;
  const [scrollOffset, setScrollOffset] = useState(0);

  const scrollFactor = Math.min(scrollOffset / maxScroll, 1);
  const scale = initialScale - (initialScale - minScale) * scrollFactor;

  const borderRadius = scale > minScale ? 32 * scrollFactor : 0;

  return (
    <>
      <Navbar></Navbar>
      <ContactForm></ContactForm>
      <FreeApp></FreeApp>
      <Footer></Footer>
    </>
  );
};
export default Contact;
